import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { AppContext } from '../appState'
import {
   BoxContainerLighter,
   H2,
   Input,
   Label,
   TwoColumnContent
} from '@welcom/esg-react-components'
import { Statusbar } from '../components/Statusbar'
import { InfoButtonModal } from '@welcom/esg-react-components/dist/molecules/InfoButton'
import { isValidSSN } from '../utils/validation'

const AlignLeft = styled.div`
   text-align: left;
`
const ErrorMessage = styled.div`
   color: #e75236;
   font-weight: bold;
   font-size: 12px;
`

export const Pupils = () => {
   const { store, dispatch, setDisableNext } = useContext(AppContext)
   const [SSN, setSSN] = useState(store.pupil.SSN ?? '')
   const [ssnError, setSsnError] = useState('')

   useEffect(() => {
      let checkIfValid = isValidSSN(SSN)
      console.log(checkIfValid)
      if (checkIfValid?.valid) {
         dispatch({
            type: 'updatePupil',
            key: 'SSN',
            value: SSN
         })
         setSsnError('')
      } else {
         dispatch({
            type: 'updatePupil',
            key: 'SSN',
            value: ''
         })
         setSsnError(checkIfValid?.error)
      }
   }, [SSN, dispatch])

   useEffect(() => {
      if (
         store.pupil.name &&
         store.pupil.surname &&
         store.pupil.SSN &&
         store.pupil.language
      ) {
         setDisableNext(false)
      } else {
         setDisableNext(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setDisableNext, store.pupil])

   return (
      <AlignLeft>
         <BoxContainerLighter>
            <Statusbar currentStep={0} />
            <H2>1. Pupils information</H2>
            <p>Fields marked with an * are required.</p>

            <TwoColumnContent>
               <div>
                  <Label required={true} HtmlFor={'name'}>
                     First Name
                  </Label>
                  <Input
                     type={'text'}
                     id={'name'}
                     value={store.pupil.name ?? ''}
                     required
                     onChange={e => {
                        dispatch({
                           type: 'updatePupil',
                           key: 'name',
                           value: e.target.value
                        })
                     }}
                  />
               </div>

               <div>
                  <Label required={true} HtmlFor={'surname'}>
                     Last Name
                  </Label>
                  <Input
                     type={'text'}
                     id={'surname'}
                     required
                     value={store.pupil.surname ?? ''}
                     onChange={e => {
                        dispatch({
                           type: 'updatePupil',
                           key: 'surname',
                           value: e.target.value
                        })
                     }}
                  />
               </div>

               <div>
                  <Label required={true} HtmlFor={'ssn'}>
                     Personal number
                  </Label>
                  <InfoButtonModal>
                     <div>
                        <p>
                           <b>Enter the personal number with 12 digits.</b>
                           <br />
                           If you don’t have last 4 numbers put an x instead of
                           the number.
                        </p>

                        <p>
                           <b>For example:</b>
                           <br />
                           20200102-XXXX
                        </p>
                     </div>
                  </InfoButtonModal>
                  <Input
                     type={'text'}
                     id={'ssn'}
                     required
                     value={SSN ?? ''}
                     pattern="^(19|20)?(\d{6}([-+]|\s)(\d{4}|x{4}|X{4}))$"
                     placeholder={'20YYMMDD-XXXX'}
                     onChange={e => {
                        setSSN(e.target.value)
                     }}
                  />
                  <ErrorMessage>{ssnError}</ErrorMessage>
               </div>

               <div>
                  <Label required={true} HtmlFor={'lang'}>
                     Languages spoken at home
                  </Label>
                  <Input
                     type={'text'}
                     id={'lang'}
                     required
                     value={store.pupil.language ?? ''}
                     onChange={e => {
                        dispatch({
                           type: 'updatePupil',
                           key: 'language',
                           value: e.target.value
                        })
                     }}
                  />
               </div>

               <div>
                  <Label HtmlFor={'prevSchool'}>
                     Previous schools or day care
                  </Label>
                  <Input
                     type={'text'}
                     id={'prevSchool'}
                     value={store.pupil.prevSchool ?? ''}
                     onChange={e => {
                        dispatch({
                           type: 'updatePupil',
                           key: 'prevSchool',
                           value: e.target.value
                        })
                     }}
                  />
               </div>

               <div>
                  <Label HtmlFor={'startDate'} required={true}>
                     When would you like to start
                  </Label>
                  <Input
                     type={'text'}
                     id={'startDate'}
                     required={true}
                     value={store.pupil.startDate ?? ''}
                     onChange={e => {
                        dispatch({
                           type: 'updatePupil',
                           key: 'startDate',
                           value: e.target.value
                        })
                     }}
                  />
               </div>
            </TwoColumnContent>
         </BoxContainerLighter>
      </AlignLeft>
   )
}
